import axios from 'axios';
import {BACKEND_URL} from '../constants/ServiceUrl'

export default {
    get() {
        return axios.get(BACKEND_URL+'Form/FieldInputType/get.php');
    }
}


// WEBPACK FOOTER //
// ./src/api/InputTypeLovApi.js